import { render, staticRenderFns } from "./articlesDIY.vue?vue&type=template&id=7ef47f2f&scoped=true&"
import script from "./articlesDIY.vue?vue&type=script&lang=js&"
export * from "./articlesDIY.vue?vue&type=script&lang=js&"
import style0 from "./articlesDIY.vue?vue&type=style&index=0&id=7ef47f2f&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef47f2f",
  null
  
)

component.options.__file = "articlesDIY.vue"
export default component.exports